import { render, staticRenderFns } from "./recruitPartner.vue?vue&type=template&id=107a9a3b&scoped=true&"
import script from "./recruitPartner.vue?vue&type=script&lang=js&"
export * from "./recruitPartner.vue?vue&type=script&lang=js&"
import style0 from "./recruitPartner.vue?vue&type=style&index=0&id=107a9a3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107a9a3b",
  null
  
)

export default component.exports